import { ProfileData } from '../model/Model';

export interface IStoredProfile {
    checkinTime?: string,
    checkoutTime?: string,
    profile: ProfileData,
    workerId: number,
}

export const listProfiles = (): string[] => {
    const results: string[] = [];
    for (let idx = 0; idx < localStorage.length; idx++) {
        const key = localStorage.key(idx)
        if (key && key.startsWith('pd_')) {
            results.push(key.substr(3));
        }
    }
    return results;
}

export const getProfile = (token: string): IStoredProfile | null => {
    const data = localStorage.getItem(`pd_${token}`);
    if (data) {
        return JSON.parse(data) as IStoredProfile;
    }
    return null;
}

export const removeProfile = (token: string): void => {
    localStorage.removeItem(`pd_${token}`);
}

export const saveProfile = (token: string, profile: IStoredProfile): void => {
    localStorage.setItem(`pd_${token}`, JSON.stringify(profile));
}
